import React, { useState, useEffect } from "react";
import { ENTORNO } from "../../utils/constantes";

////////////////////
//notificacion
import { initializeApp } from "@firebase/app";
import { getMessaging, getToken, onMessage } from "@firebase/messaging";

const app = initializeApp(ENTORNO.firebaseConfig);
export const messaging = getMessaging(app);
///////////////////

export function PruebaTokenFirebase() {
  // useEffect(() => {
  //   (async () => {
  //     //activar escucha de notificaciones
  //     setError("Activando notificaciones desde useEffect");

  //     onMessage(messaging, (message) => {
  //       setNotificacionUsuario(message.notification.title);
  //     });
  //   })();
  // });

  /////////////////////////
  //notificaciones
  const [Permisos, setPermisos] = useState("");
  const [TokenUsuario, setTokenUsuario] = useState("");
  const [NotificacionUsuario, setNotificacionUsuario] = useState("");
  const [Error, setError] = useState("");

  const permitirNotificaciones = async () => {
    try {
      //preguntar si quiere recibir notificaciones
      const permission = await Notification.requestPermission();
      setPermisos(permission);

      if (permission === "granted") {
        //obtener token
        let token = "";
        token = await getToken(messaging, {
          vapidKey: ENTORNO.vapidKey,
        }).catch((error) => setError(error));

        if (token) setTokenUsuario(token);
        if (!token) setError("Error token 1");

        //activar escucha de notificaciones
        onMessage(messaging, (message) => {
          setNotificacionUsuario(message.notification.title);
        });
      }
    } catch (error) {
      setError(error);
    }
  };
  /////////////////////////

  return (
    <div style={{ padding: "30px", paddingRight: "30px" }}>
      <br></br>
      <br></br>
      <br></br>
      <button onClick={permitirNotificaciones}>Permitir notificaciones</button>
      <br></br>
      <br></br>
      Permisos: {Permisos}
      <br></br>
      <br></br>
      Token usuario firebase: {TokenUsuario}
      <br></br>
      <br></br>
      Notificacion recibida: {NotificacionUsuario}
      <br></br>
      <br></br>
      Error: {Error}
    </div>
  );
}
